import Vue from 'vue';
interface Binding {
    name?: string;
    oldValue?: any;
    value?: any;
    expression?: any;
    arg?: any;
    modifiers?: any;
}

function loadImgAsync(url: string) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            resolve(true);
        };
        img.onerror = () => {
            resolve(false);
        };
        img.src = url;
    });
}

function setImgSrc(el: HTMLElement, url: string) {
    el.setAttribute('src', url);
}

async function handleImgLoadErr(el: HTMLElement, binding: Binding, vnode: any) {
    const imgUrl = binding.value;

    el.style.backgroundColor = 'rgb(224, 224, 224, 0.5)';
    if (imgUrl) {
        const exist = await loadImgAsync(imgUrl);

        if (exist) {
            setImgSrc(el, imgUrl);
        }
    }
}

export default Vue.directive('imgErr', handleImgLoadErr);
